<!--
  lovi 浮动客服
  2020-3-30
-->
<template>
  <div>
    <div
      class="float-service"
      @click.stop="_linkFun('/service')"
      @mousedown="dragDown"
      @touchstart="dragDown"
      @mousemove="dragMove"
      @touchmove="dragMove"
      @mouseup="dragEnd"
      @touchend="dragEnd"
      ref="moveDrag"
    ></div>
  </div>
</template>

<script>
import { addClass, removeClass } from "@/commonJs/index";
export default {
  components: {},
  data() {
    return {
      //拖拽
      dragFlags: false,
      position: {
        x: 0,
        y: 0
      },
      nx: "",
      ny: "",
      dx: "",
      dy: "",
      xPum: "",
      yPum: ""
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    //实现拖拽
    dragDown() {
      this.dragFlags = true;
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = this.$refs.moveDrag.offsetLeft;
      this.dy = this.$refs.moveDrag.offsetTop;
    },
    dragMove() {
      if (this.dragFlags) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.xPum = this.dx + this.nx;
        this.yPum = this.dy + this.ny;
        this.$refs.moveDrag.style.left = this.xPum + "px";
        this.$refs.moveDrag.style.top = this.yPum + "px";
        // document.addEventListener('touchmove', function() { //阻止页面的滑动默认事件
        // 	event.preventDefault();
        // }, false);
      }
    },
    dragEnd() {
      //鼠标释放时候的函数
      var touch;
      var maxWidth = document.body.clientWidth;
      var maxHeight = document.body.clientHeight;
      var selfWidth = this.$refs.moveDrag.offsetWidth;
      var selfHeight = this.$refs.moveDrag.offsetHeight;
      if (event.changedTouches) {
        touch = event.changedTouches[0];
      } else {
        touch = event;
      }
      this.nx = touch.clientX - this.position.x;
      this.ny = touch.clientY - this.position.y;
      this.xPum = this.dx + this.nx;
      this.yPum = this.dy + this.ny;
      // console.log(this.xPum, 'this.xPum', this.yPum, 'this.yPum')
      if (this.xPum < 0) {
        this.xPum = 0;
      }
      if (this.xPum > maxWidth - selfWidth) {
        this.xPum = maxWidth - selfWidth;
      }
      if (this.yPum < 0) {
        this.yPum = 0;
      }
      if (this.yPum > maxHeight - selfHeight) {
        this.yPum = maxHeight - selfHeight;
      }

      if (this.yPum > 100 && this.yPum < maxHeight - selfHeight) {
        if ((maxWidth - selfWidth) / 2 > this.xPum) {
          this.xPum = 0;
        } else {
          this.xPum = maxWidth - selfWidth;
        }
      }

      // if (this.xPum < 0 || ((maxWidth - selfWidth) / 2) > this.xPum) {
      // 	this.xPum = 0
      // } else {
      // 	this.xPum = maxWidth - selfWidth
      // }

      addClass(this.$refs.moveDrag, "transition-drag");
      setTimeout(() => {
        removeClass(this.$refs.moveDrag, " transition-drag");
      }, 500);
      this.$refs.moveDrag.style.left = this.xPum + "px";
      this.$refs.moveDrag.style.top = this.yPum + "px";
      this.dragFlags = false;
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.float-service {
  position: fixed;
  bottom: 50px;
  right: 10px;
  z-index: 300;
  width: 56px;
  height: 56px;
  background-image: url("~@/assets/images/public/icon_service@2x.png");
  background-repeat: no-repeat;
  background-size: 100%;
  animation: fadeIn 1.5s;
}
@keyframes fadeIn {
  from {
    right: -60px;
  }
  to {
    right: 10px;
  }
}
.transition-drag {
  // transition: top .5s, left .5s;
}
</style>
